/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { AuthRegisterRequest, AuthRegisterResponse } from '../types/AuthRegister'

/**
 * POST /auth/register
 * @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::register
 */
export async function authRegister(
	data: AuthRegisterRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<AuthRegisterResponse>> {
	return axiosInstance.post('/auth/register', data, config)
}
